export default __webpack_public_path__ + "static/media/11n.04537106.svg";